import React, { useState, useEffect, useContext } from 'react';

import Cookies from 'js-cookie';

import Dropdown from '../../common/Dropdown/index.js'
import CampaignMenu from '../CampaignMenu.js'

import { UserDataContext } from "../../../App.js";

function RulesMenuSkills(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------
    let [currentChar, setChar] = [ props.state[0], props.state[1] ];
    let [layout, setLayout] = [ props.state[3], props.state[4] ];
    const [userData, setUserData] = useContext(UserDataContext);
    const [isPlaying, setIsPlaying] = props.state[8];

    const setRule = props.setRule

    // -------- local state variables --------
    const [isTTS, setIsTTS] = useState(/Tabletop/i.test(navigator.userAgent));


    let menuOptions = [
            'Turn Undead',
            'Thief Skills',
            'Scroll Failure'
            // ...(userData.loggedIn ? ['View > DM'] : []),
          ];

    // -------------------------------------
    // EVENT HANDLER
    // -------------------------------------

    const handleMenu = async (selection) => {
        // Implement the various menu options here

    let Img;
    let imgSet = false;


    if ( menuOptions[selection] === 'Turn Undead' ) {
            Img = require(`../../../pdf/TurnUndead.jpg`)
            imgSet = true;
        }

        if ( menuOptions[selection] === 'Thief Skills' ) {
            Img = require(`../../../pdf/ThiefSkills.jpg`)
            imgSet = true;
        }

        if ( menuOptions[selection] === 'Scroll Failure' ) {
            Img = require(`../../../pdf/ScrollFailure.jpg`)
            imgSet = true;
        }

        // DISPLAY IMAGE IN WINDOW (if set)
        if ( imgSet ) {
            if ( props.setRule ) {
                setRule( { title: menuOptions[selection], source: Img })
            }

            document.getElementById('rulesWindow').style.display = 'block';
            // document.getElementsByClassName('rules-menu')[0].style.display = 'none';
            return;
        }


    } // end of HANDLE FUNCTION


    return (
    
        <>
        <Dropdown
            trigger = {<button className="nav-settings-button">Skills</button>}
            menu = { menuOptions.map ( ( option, idx) => {

                if  ( option === 'Change Campaign' ) return <CampaignMenu key={idx} {...props} />

                else return <button id={'discord-option-' + idx } onClick={()=>handleMenu(idx)}>{option}</button>

                }
            )}
            divClass='menu-item sub-menu'
            menuClass="menu"
            onChildClose={props.onChildClose}
        />
        </>
    )

    };  // end of function

    export default RulesMenuSkills